import { ApprovalMat } from '@/_features/motoboys/approval-mat';

function CloudApprovalMat() {
  return (
    <div className="container">
      <ApprovalMat />
    </div>
  );
}

export default CloudApprovalMat;
